module.exports = __webpack_public_path__ + "img/Data Workflows-Active.452f7c95.svg";